// @ts-check
import React from "react";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useAISidebar } from "src/hooks/useAISidebar";
import { AIChatWindow, AIChatWindowWithAgentCore } from "../AIContent";

export const AINav = () => {
  const { enableAIChat, enableAgentCore } = useWorkspaceFeatureFlags();

  const { isOpen } = useAISidebar();

  if (!enableAIChat) {
    return null;
  }

  if (enableAgentCore) {
    return <AIChatWindowWithAgentCore isOpen={isOpen} />;
  }

  // Always render the component but conditionally show content
  return isOpen && <AIChatWindow />;
};
